/* Header behaviour. Extracted from sections/header-nycdd.liquid so it ships cached
   instead of ~6.7KB inline on every page. Root lookup switched from the per-section
   id to the .nycdd-header class so no Liquid is needed. */
(function() {
    var root = document.querySelector('.nycdd-header');
    if (!root) return;



    // Comp keeps the navy pre-header visible above the drawer.
    function setDrawerTop() {
      var bar = root.querySelector('.topbar-mobile');
      var h = (bar && bar.offsetParent !== null) ? Math.round(bar.getBoundingClientRect().bottom) : 0;
      root.style.setProperty('--mdrawer-top', Math.max(0, h) + 'px');
    }
    setDrawerTop();
    window.addEventListener('resize', setDrawerTop);
    window.addEventListener('scroll', setDrawerTop, { passive: true });

    // Mobile drawer drill-down: root <-> one panel per mega-menu item.
    var levels = root.querySelectorAll('[data-drawer-level], [data-drawer-panel]');
    var scroller = root.querySelector('.mdrawer__scroll');
    function showLevel(el) {
      levels.forEach(function (l) { l.hidden = (l !== el); });
      if (scroller) scroller.scrollTop = 0;
    }
    function drawerRoot() { return root.querySelector('[data-drawer-level="root"]'); }
    root.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = root.querySelector('[data-drawer-panel="' + btn.getAttribute('data-drawer-open') + '"]');
        if (panel) showLevel(panel);
      });
    });
    root.querySelectorAll('[data-drawer-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { showLevel(drawerRoot()); });
    });
    // Always reopen on the root level, never mid-drill.
    root.querySelectorAll('[data-nycdd-header-toggle="drawer"]').forEach(function (t) {
      t.addEventListener('click', function () { showLevel(drawerRoot()); });
    });

    // Hide blue pre-header on scroll; show again at top
    var scrollThreshold = 60;
    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        root.classList.add('header-scrolled');
      } else {
        root.classList.remove('header-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var backdrop = root.querySelector('[data-nycdd-header="backdrop"]');
    var panel = root.querySelector('[data-nycdd-header="panel"]');
    if (!backdrop || !panel) return;

    function openDrawer() {
      backdrop.classList.remove('pointer-events-none');
      backdrop.classList.add('pointer-events-auto');
      backdrop.classList.add('opacity-100');
      backdrop.classList.remove('opacity-0');
      panel.classList.remove('translate-x-[-100%]');
      panel.classList.add('translate-x-0');
      document.documentElement.classList.add('overflow-hidden');
    }

    function closeDrawer() {
      backdrop.classList.add('pointer-events-none');
      backdrop.classList.remove('pointer-events-auto');
      backdrop.classList.remove('opacity-100');
      backdrop.classList.add('opacity-0');
      panel.classList.add('translate-x-[-100%]');
      panel.classList.remove('translate-x-0');
      document.documentElement.classList.remove('overflow-hidden');
    }

    root.querySelectorAll('[data-nycdd-header-toggle="drawer"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (backdrop.classList.contains('pointer-events-none')) {
          openDrawer();
        } else {
          closeDrawer();
        }
      });
    });

    backdrop.addEventListener('click', function(e) {
      if (e.target === backdrop) {
        closeDrawer();
      }
    });

    // Top bar mobile carousel
    var topbar = root.querySelector('[data-nycdd-topbar]');
    if (topbar) {
      var slides = topbar.querySelectorAll('[data-nycdd-topbar-slide]');
      var index = parseInt(topbar.getAttribute('data-index') || '1', 10);
      function setIndex(i) {
        index = (i + slides.length) % slides.length;
        topbar.setAttribute('data-index', String(index));
        slides.forEach(function(slide) {
          var slideIndex = parseInt(slide.getAttribute('data-nycdd-topbar-slide') || '0', 10);
          if (slideIndex === index) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });
      }
      setIndex(index);
      var prevBtn = topbar.querySelector('[data-nycdd-topbar-prev]');
      var nextBtn = topbar.querySelector('[data-nycdd-topbar-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          setIndex(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          setIndex(index + 1);
        });
      }
    }
  })();

/* Desktop mega nav: intent-based open/close. Pure :hover fails because the panel sits
     below the header row, so travelling toward it crosses a gap and drops the hover. */
  (function () {
    var root = document.querySelector('.nycdd-header');
    if (!root || root.dataset.navInit) return;
    root.dataset.navInit = '1';
    var items = root.querySelectorAll('.nycdd-nav__item.has-panel');
    if (!items.length) return;
    var timer = null;
    var desktop = function () { return window.matchMedia('(min-width: 1024px)').matches; };

    function closeAll() {
      items.forEach(function (i) {
        i.classList.remove('is-open');
        var t = i.querySelector('.nycdd-nav__link');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    function open(item) {
      clearTimeout(timer);
      items.forEach(function (i) { if (i !== item) i.classList.remove('is-open'); });
      item.classList.add('is-open');
      var t = item.querySelector('.nycdd-nav__link');
      if (t) t.setAttribute('aria-expanded', 'true');
    }
    function scheduleClose() {
      clearTimeout(timer);
      timer = setTimeout(closeAll, 220);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { if (desktop()) open(item); });
      item.addEventListener('mouseleave', function () { if (desktop()) scheduleClose(); });
      /* keep it open while the pointer is inside the panel itself */
      var panel = item.querySelector('.nycdd-mega');
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
        panel.addEventListener('mouseleave', function () { if (desktop()) scheduleClose(); });
      }
      var link = item.querySelector('.nycdd-nav__link');
      if (link) link.addEventListener('focus', function () { if (desktop()) open(item); });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) closeAll();
    });
  })();
